const GeneralStatisticsTypes = {
     GET_GENERAL_STATISTICS_START:' GET_GENERAL_STATISTICS_START',
     GET_GENERAL_STATISTICS_SUCCESS:' GET_GENERAL_STATISTICS_SUCCESS',
     GET_GENERAL_STATISTICS_FAILED:' GET_GENERAL_STATISTICS_FAILED',
     SET_CURRENTLY_DISPLAYED_GENERAL_STANDING:'SET_CURRENTLY_DISPLAYED_GENERAL_STANDING'

}

export default GeneralStatisticsTypes